import { __zcAsy, __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'

const WhitepaperContentTypes = z.lazy(() => z.enum(['whitepaper', 'ebook']))
const WhitepaperCategories = z.lazy(() =>
  z.enum([
    'ai',
    'cloud',
    'devops',
    'github-actions',
    'github-advanced-security',
    'github-enterprise',
    'innersource',
    'open-source',
    'security',
    'software-development',
  ]),
)

/**
 * Payload schema for whitepaper index pages.
 */
export const WhitepaperIndexPayloadSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    additionalProps: z.object({
      page: z.number(),
      totalPages: z.number(),
      filters: z.object({
        contentTypes: safeOptional(z.array(WhitepaperContentTypes)),
        topics: safeOptional(z.array(WhitepaperCategories)),
      }),
    }),
  }),
);
var __rf=[__zs._zod.innerType.shape["additionalProps"].shape["filters"].shape["contentTypes"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs._zod.innerType.shape["additionalProps"].shape["filters"].shape["topics"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_13=__rf[0];
var __rfn_17=__rf[1];
function __vb_3(input){var __bv_4,__bv_5,__bs_6,__bv_7,__bv_8,__bv_9,__bv_10,__bv_11,__bx_12,__bw_14,__bv_15,__bx_16,__bw_18,__bo_19,__bo_20,__bo_21;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_4=input["userLoggedIn"];if(!((__bv_4===undefined||(typeof __bv_4==="boolean"))))return __bf_2;__bv_5=input["contentfulRawJsonResponse"];if(!(typeof __bv_5==="object"&&__bv_5!==null&&!Array.isArray(__bv_5)))return __bf_2;__bs_6=__zcPs(__bv_5);__bv_7=input["additionalProps"];if(typeof __bv_7!=="object"||__bv_7===null||Array.isArray(__bv_7))return __bf_2;__bv_8=__bv_7["page"];if(!(Number.isFinite(__bv_8)))return __bf_2;__bv_9=__bv_7["totalPages"];if(!(Number.isFinite(__bv_9)))return __bf_2;__bv_10=__bv_7["filters"];if(typeof __bv_10!=="object"||__bv_10===null||Array.isArray(__bv_10))return __bf_2;__bv_11=__bv_10["contentTypes"];if(__bv_11===undefined){__bw_14=undefined;}else{__bx_12=__rfn_13(__bv_11);if(__bx_12 instanceof Promise)__zcAsy();__bw_14=__bx_12;}__bv_15=__bv_10["topics"];if(__bv_15===undefined){__bw_18=undefined;}else{__bx_16=__rfn_17(__bv_15);if(__bx_16 instanceof Promise)__zcAsy();__bw_18=__bx_16;}__bo_19={};if(__bw_14!==undefined||("contentTypes" in __bv_10)){__bo_19["contentTypes"]=__bw_14;}if(__bw_18!==undefined||("topics" in __bv_10)){__bo_19["topics"]=__bw_18;}__bo_20={"page":__bv_8,"totalPages":__bv_9,"filters":__bo_19};__bo_21={"contentfulRawJsonResponse":__bs_6};if(__bv_4!==undefined||("userLoggedIn" in input)){__bo_21["userLoggedIn"]=__bv_4;}__bo_21["additionalProps"]=__bo_20;return __bo_21;}
var __rfm_z=__zs.safeParse;
function safeParse_WhitepaperIndexPayloadSchema(input){
var __bd_22=__vb_3(input);
if(__bd_22!==__bf_2){return{success:true,data:__bd_22};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_WhitepaperIndexPayloadSchema,__zs,null,null);
})()

export type WhitepaperIndexPayload = z.infer<typeof WhitepaperIndexPayloadSchema>

export function toWhitepaperIndexPayload(payload: unknown): WhitepaperIndexPayload {
  return WhitepaperIndexPayloadSchema.parse(payload)
}
